import { IBase } from 'src/app/core';

export interface IFilemeasurement extends IBase {
  temp: number;
  receiptTime: string;
  ecg: number;
  pcg: number;
  ppg: number;
}
